
<div class="col-6">
    <select class="form-select" [(ngModel)]="SelectedFilterOption" (ngModelChange)="updateFilterSettings()" [compareWith]="compareFilterOptions">
        <option *ngFor="let option of Options" [ngValue]="option">
            {{ option.Name }}
        </option>
    </select>
</div>
<div class="col-6">
    <div class="row">
        <div class="col">
            <select class="form-select" [(ngModel)]="SelectedListOption" (ngModelChange)="updateFilterSettings()">
                <option *ngFor="let option of FilterInputs" [ngValue]="option">
                    {{ option.Text }}
                </option>
            </select>
        </div>
    </div>
</div>